import React from "react";
import { Link } from "react-router-dom";
import { Music, Mic, AudioWaveform, Megaphone, Headphones, Radio, Film, Tv } from "lucide-react";

const SERVICES = [
  { icon: Music, title: "Custom Theme Songs", text: "Original songs built around your brand voice, values, and story." },
  { icon: Mic, title: "Business Jingles", text: "Short, catchy hooks designed to be remembered after the first listen." },
  { icon: AudioWaveform, title: "Brand Soundtracks", text: "Ambient and background music for your venues, ads, and platforms." },
  { icon: Megaphone, title: "Commercial Music", text: "Music written specifically for ad campaigns, social, and broadcast." },
  { icon: Headphones, title: "Podcast Intros & Outros", text: "Signature audio identity for your podcast or audio content." },
  { icon: Radio, title: "Radio Commercial Jingles", text: "Production-ready jingles formatted for radio buys." },
  { icon: Film, title: "Video Soundtracks", text: "Cinematic music for corporate videos, product launches, and films." },
  { icon: Tv, title: "TV Advertising Music", text: "Broadcast-quality music tailored for television advertising." },
];

export default function Services() {
  return (
    <div className="bg-black">
      <div className="container-x section">
        <div className="text-center mb-16">
          <div className="eyebrow mb-3">Our Services</div>
          <h1 className="font-heading text-4xl md:text-5xl mb-4">Music That Builds Brands</h1>
          <p className="text-white/65 max-w-2xl mx-auto">From concept to final master, Songniture handles every aspect of custom music production for businesses that care about how they sound.</p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {SERVICES.map((s, i) => (
            <div key={s.title} className="card p-7 flex flex-col gap-4 hover:-translate-y-1 duration-300" data-testid={`service-${i}`}>
              <s.icon className="text-gold" size={32} strokeWidth={1.4} />
              <h3 className="font-heading text-xl text-white">{s.title}</h3>
              <p className="text-white/60 text-sm leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
        <div className="mt-16 text-center">
          <Link to="/pricing" className="btn-gold" data-testid="services-view-pricing">View Pricing & Packages</Link>
        </div>
      </div>
    </div>
  );
}
